import "./styles.scss";
import "./components/_privacy-policy.scss";